export const converterFileTypes = {
    PDF: 0,
    DOCX: 1,
};

export const converterUrls = {
    [converterFileTypes.PDF]: "https://ckeditor-pdf.greenwave-257981d3.westeurope.azurecontainerapps.io/v1/convert",
    [converterFileTypes.DOCX]: "https://ckeditor-docx.greenwave-257981d3.westeurope.azurecontainerapps.io/v1/convert",
};
